import { Component } from "react";
import { tr } from "./i18n.js";

/**
 * Fără asta, o singură componentă care crapă lasă ecranul complet gol: React
 * demontează tot arborele. S-a întâmplat exact așa — o cheie de API umbrită a
 * dărâmat pagina de Parc, iar odată cu ea navigarea, deci utilizatorul nici
 * măcar nu putea trece la altă secțiune.
 *
 * Aici defectul rămâne local: restul aplicației funcționează, iar ecranul spune
 * ce s-a întâmplat în loc să tacă.
 */
export default class PlasaDeSiguranta extends Component {
  constructor(props) {
    super(props);
    this.state = { eroare: null };
  }

  static getDerivedStateFromError(eroare) {
    return { eroare };
  }

  componentDidCatch(eroare, info) {
    // Consola rămâne sursa de adevăr pentru diagnostic: plasa prinde afișarea,
    // nu ascunde defectul.
    console.error("Secțiune căzută:", eroare, info?.componentStack);
  }

  componentDidUpdate(props) {
    // La schimbarea secțiunii, plasa se resetează: altfel un defect dintr-un
    // ecran ar ține blocate și celelalte.
    if (props.cheie !== this.props.cheie && this.state.eroare) {
      this.setState({ eroare: null });
    }
  }

  render() {
    if (!this.state.eroare) return this.props.children;
    return (
      <div className="continut">
        <h1>{tr("Secțiunea asta nu s-a putut afișa")}</h1>
        <p className="subtitlu">
          {tr("E un defect al aplicației, nu ceva ce ai greșit tu. Restul secțiunilor funcționează — treci la alta din meniul de sus.")}
        </p>
        <div className="panou panou-atentie">
          <div className="panou-corp">
            <strong>{tr("Ce s-a întâmplat:")}</strong>{" "}
            <code>{String(this.state.eroare?.message ?? this.state.eroare)}</code>
            <p className="nota-cautare" style={{ marginTop: ".6rem" }}>
              {tr("Dacă se repetă, trimite dezvoltatorului textul de mai sus și ce secțiune încercai să deschizi.")}
            </p>
          </div>
        </div>
        <button className="buton buton-actiune" onClick={() => this.setState({ eroare: null })}>
          {tr("încearcă din nou")}
        </button>
      </div>
    );
  }
}
